import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router';
// import history from '../../history';
import {Translate, I18n} from 'react-redux-i18n';
import axios from 'axios';

import Loading from '../../components/Loading/Loading';
import style from './ExerciseWaitingRoom.module.css';
import {
  renameUser as renameUserAction,
  kickUser as kickUserAction,
  run as runAction,
} from '../Exercise/ExerciseActions';

import {
  selectUser as selectUserAction,
} from './ExerciseWaitingRoomActions';

function ExerciseWaitingRoom(props) {
  const {
      loading,
      selected,
      exercise,
      selectUser,
      renameUser,
      kickUser,
      run: runProp,
      id: propId
  } = props;

  const { id: paramId } = useParams();
  const id = propId || paramId;
  const navigate = useNavigate();

  const [benchmarks, setBenchmarks] = useState([]);

  useEffect(() => {
    (async ()=>{
      try {
        const response = await axios.get('/api/companies/benchmarks', {
          headers: {
              'Authorization': window.localStorage.getItem("token")
          },
          validateStatus: (status) => status < 400
        })
        setBenchmarks(response.data.benchmarks);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  function back() {
    navigate('/exercises');
  }

  function run() {
    runProp(id);
    global.socket.emit('play_start');
  }

  function rename() {
    const newName = window.prompt(I18n.t("exerciseWaiting.renamePrompt"));
    renameUser(selected, newName);
  }

  function kick() {
    if (window.confirm(I18n.t("exerciseWaiting.kickConfirm"))) {
      kickUser(selected);
    }
  }

  function handleSelectChange(e) {
    e.preventDefault();
    selectUser(e.target.value);
  }

  const { name, scenario, code, users } = exercise;

  let usersList = ( users || []).filter(user => user.type !== 'ORGANIZER');

  const ready = (users || []).every(user => user.status === 'READY');

  const selectedUser = (users || []).find(user => user.id === selected);
  const selectedIsOrganizer = selectedUser && selectedUser.type === 'ORGANIZER';

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        { loading && <Loading /> }
        <h3><strong><Translate value="exerciseWaiting.title"/></strong></h3>
        <hr />
          <Translate value="exerciseWaiting.desc"/>
        <p>
          <strong><Translate value="exercise.Exercise"/>:</strong> { name }
          <br />
          <strong><Translate value="exercise.Scenario"/>:</strong> { scenario && scenario.title }
          <br />
          <strong><Translate value="exercise.Code"/>:</strong> { code }
        </p>
        <div className="row">
          <div className="col-sm-12">
            <h4><i className="fas fa-users" /><Translate value="exercise.Participants"/>
            </h4>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <select
              value={selected}
              onChange={handleSelectChange}
              size="10"
              className={style.select}
            >
              <option value="" hidden />
              {
                (usersList || []).map(user => (
                  <option
                    key={user.id}
                    value={user.id}
                  >{user.name} ({user.status})</option>
                ))
              }
            </select>
          </div>
          <div className="col-sm-4">
            {/*<button*/}
              {/*className={`btn btn-primary ${style.btn}`}*/}
              {/*onClick={rename}*/}
              {/*disabled={!selected || loading}*/}
            {/*>*/}
              {/*<i className="fas fa-edit" /> <Translate value="controls.Rename"/>*/}
            {/*</button>*/}
            <button
              className={`btn btn-danger ${style.btn}`}
              onClick={kick}
              disabled={!selected || loading || selectedIsOrganizer}
            >
              <i className="fas fa-user-times" /> <Translate value="exerciseWaiting.Disconnect"/>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <button
              className="btn btn-danger float-end"
              onClick={back}
              disabled={loading}
            >
              <i className="fas fa-times" /> <Translate value="controls.Cancel"/>
            </button>
            <button
              className="btn btn-primary"
              onClick={run}
              disabled={loading || !ready}
            >
              <Translate value="exerciseWaiting.Start"/> <i className="fas fa-arrow-right" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ExerciseWaitingRoom.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  exercise: PropTypes.object,
  selected: PropTypes.string,
  selectUser: PropTypes.func,
  renameUser: PropTypes.func,
  kickUser: PropTypes.func,
  run: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.exercise.loading,
  exercise: state.exercise.exercise,
  selected: state.exerciseWaitingRoom.selected,
});

const mapDispatchToProps = {
  selectUser: selectUserAction,
  renameUser: renameUserAction,
  kickUser: kickUserAction,
  run: runAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExerciseWaitingRoom);

